/**
 * @file objectCopyUtils.js
 * @description functions to copy sourceObj to targetObj for
 *              several different object types
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sep 29, 2025 20:05
 */

export function copyObject(sourceObj, targetObj) {
    // generic object property copy

    if (sourceObj) {

        for (const key in sourceObj) {

            if (typeof sourceObj[key] !== 'function') {

                // the property must exist in the target
                if (Object.hasOwn(targetObj, key)) {

                    if (sourceObj[key]) {
                        targetObj[key] = sourceObj[key];
                    }

                }
            }
        }
    }
}